import { Stack, Typography, Box } from '@mui/material';
import ApiKeyRow from './ApiKeyRow';
import type { ApiKey } from '@/types';

interface ApiKeyListProps {
  apiKeys: ApiKey[];
  onRevoke: (keyId: string) => void;
  isRevoking: boolean;
}

export default function ApiKeyList({ apiKeys, onRevoke, isRevoking }: ApiKeyListProps) {
  if (apiKeys.length === 0) {
    return (
      <Box
        sx={{
          textAlign: 'center',
          py: 4,
          color: 'text.secondary',
          bgcolor: 'background.paper',
          borderRadius: 1,
          border: '1px dashed',
          borderColor: 'divider',
        }}
      >
        <Typography variant="body1">
          还没有 API Key，创建一个开始使用吧。
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={1.5}>
      {apiKeys.map((key) => (
        <ApiKeyRow
          key={key.id}
          apiKey={key}
          onRevoke={onRevoke}
          isRevoking={isRevoking}
        />
      ))}
    </Stack>
  );
}
